import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";


export const GetDashboard = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Dashboard/GetDashboard?` + params, null);